import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
  Redirect,
} from 'react-router-dom';

import { useGameTheme } from '../GameThemeContext';
import { FeaturesCard } from './features-card/FeaturesCard';

import { Otp } from './otp/Otp';
import { Signin } from './signin/Signin';
import { Signup } from './signup/Signup';

export function Authentication(): JSX.Element {
  const match = useRouteMatch();
  const theme = useGameTheme();
  return (
    <div className='authentication-container'>
      <div className={theme?.gameId
        ? `card-container ${theme.gameId}` : 'card-container'}
      >
        <div className='card-container-flex'>
          <Switch>
            <Route path={`${match.path}/signin/:gameId?`} exact>
              <Signin />
            </Route>
            <Route path={`${match.path}/signup/:gameId?`} exact>
              <Signup />
            </Route>
            <Route path={`${match.path}/otp/:gameId?`} exact>
              <Otp />
            </Route>
            <Redirect to={`${match.path}/signin/:gameId?`} />
          </Switch>
          {!theme.gameId && <FeaturesCard />}
        </div>
      </div>
    </div>
  );
}
